export enum AuftraggeberRoutes {
  // Aufgaben
  AG_AUFGABEN_LISTE = 'aufgabenListeAuftraggeber',

  // Bürgschaft Detailansicht
  AG_BUERGSCHAFT_LISTE = 'buergschaftenListeAuftraggeber',

  AG_BUERGSCHAFT_DETAIL = 'buergschaftDetailsAuftraggeber',

  AG_BUERGSCHAFT_AKZEPTIEREN = 'buergschaftAkzeptierenAuftraggeber',
  AG_BUERGSCHAFT_AKZEPTIEREN_ERFOLG = 'buergschaftAkzeptierenErfolgAuftraggeber',

  AG_BUERGSCHAFT_DOKUMENT_MANUELLER_UPLOAD = 'buergschaftsdokumentManuellerUploadAuftraggeber',
  AG_BUERGSCHAFT_DOKUMENT_MANUELLER_ENTFERNEN = 'buergschaftsdokumentManuellerEntfernenAuftraggeber',

  AG_BUERGSCHAFT_ZUORDNEN_OPTIONEN = 'bürgschaftProjektZuordnenOptionenAuftraggeber',

  // Bürgschaft importieren
  AG_BUERGSCHAFT_IMPORTIEREN = 'auftraggeber-buergschaft-importieren-base',
  AG_BUERGSCHAFT_IMPORTIEREN_AUSWAHL = 'auftraggeber-buergschaft-importieren-auswahl',
  AG_BUERGSCHAFT_IMPORTIEREN_BETEILIGTE = 'auftraggeber-buergschaft-importieren-beteiligte',
  AG_BUERGSCHAFT_IMPORTIEREN_DATEN = 'auftraggeber-buergschaft-importieren-daten',
  AG_BUERGSCHAFT_IMPORTIEREN_PRUEFEN = 'auftraggeber-buergschaft-importieren-pruefen',
  // Inanspruchnahme Workflow
  AG_INANSPRUCHNAHME_BASE = 'auftraggeber-inanspruchnahme-base',
  AG_INANSPRUCHNAHME_ANGABEN = 'auftraggeber-inanspruchnahme-angaben',
  AG_INANSPRUCHNAHME_ANSPRECHPARTNER = 'auftraggeber-inanspruchnahme-ansprechpartner',
  AG_INANSPRUCHNAHME_PRUEFEN = 'auftraggeber-inanspruchnahme-pruefen',

  // Enthaftung angefordert
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE = 'auftraggeber-rueckforderung-pruefen-aufgabe-base',
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE_PRUEFEN = 'auftraggeber-rueckforderung-pruefen-aufgabe-pruefen',
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE_ENTSCHEIDUNG = 'auftraggeber-rueckforderung-pruefen-aufgabe-entscheidung',
  AG_RUECKFORDERUNG_BUERGSCHAFT_PRUEFEN_AUFGABE_BESTAETIGEN = 'auftraggeber-rueckforderung-pruefen-aufgabe-bestaetigen',
  AG_BUERGSCHAFT_ABGETRETEN_DETAIL = 'buergschaftAbgetretenDetailsAuftraggeber',
  // Abgetretene Bürgschaft Detailansicht
  // Bürgschaft-Abtreten
  AG_BUERGSCHAFT_ABTRETEN = 'auftraggeber-buergschaft-abtreten-base',
  AG_BUERGSCHAFT_ABTRETEN_EMPFAENGER = 'auftraggeber-buergschaft-abtreten-empfaenger',
  AG_BUERGSCHAFT_ABTRETEN_ANSPRECHPARTNER = 'auftraggeber-buergschaft-abtreten-ansprechpartner',
  AG_BUERGSCHAFT_ABTRETEN_PRUEFEN = 'auftraggeber-buergschaft-abtreten-pruefen',
  AG_BUERGSCHAFT_ABTRETEN_BESTAETIGEN = 'auftraggeber-buergschaft-abtreten-bestaetigen',
  // Abtretung prüfen
  AG_ABTRETUNG_PRUEFEN_AUFGABE = 'auftraggeber-abtretung-pruefen-aufgabe-base',
  AG_ABTRETUNG_PRUEFEN_AUFGABE_PRUEFEN = 'auftraggeber-abtretung-pruefen-aufgabe-pruefen',
  AG_ABTRETUNG_PRUEFEN_AUFGABE_ENTSCHEIDUNG = 'auftraggeber-abtretung-pruefen-aufgabe-entscheidung',
  AG_ABTRETUNG_PRUEFEN_AUFGABE_BESTAETIGEN = 'auftraggeber-abtretung-pruefen-aufgabe-bestaetigen',
  // Projekt Details Bearbeiten
  AG_PROJEKT_FORM_BEARBEITEN = 'auftraggeber-projekt-bearbeiten-base',
  AG_PROJEKT_FORM_ANLEGEN = 'auftraggeber-projekt-anlegen-base',
  AG_PROJEKT_FORM_DETAILS = 'auftraggeber-projekt-form-details',
  AG_PROJEKT_FORM_VERANTWORTLICHES_UNTERNEHMEN = 'auftraggeber-projekt-form-verantwortliches-unternehmen',
  AG_PROJEKT_FORM_SICHTBERECHTIGUNG = 'auftraggeber-projekt-form-sichtberechtigung',

  AG_VERTRAEGE_LISTE = 'verträgeListeAuftraggeber',

  AG_VERTRAG_DETAILS = 'vertragDetailsAuftraggeber',

  AG_VERTRAG_ANLEGEN = 'auftraggeber_vertrag_anlegen_base',
  AG_VERTRAG_ANLEGEN_VERTRAGSDATEN = 'auftraggeber_vertrag_anlegen_vertragsdaten_eingeben',
  AG_VERTRAG_ANLEGEN_UNTERNEHMEN = 'auftraggeber_vertrag_anlegen_unternehmen_verknuepfen',
  AG_VERTRAG_ANLEGEN_ZUSAMMENFASSUNG = 'auftraggeber_vertrag_anlegen_zusammenfassung',

  AG_VERTRAG_BUERGSCHAFTEN_ZUORDNEN = 'auftraggeber_vertrag_buergschaften_zuordnen_base',

  // Sonstige Folgeprozesse
  AG_BUERGSCHAFT_TEILENTHAFTUNG_EINTRAGEN = 'auftraggeber-buergschaft-teilenthaftung-eintragen',

  // Avallinien-Management
  AG_AVALLINIEN_LISTE = 'avallinienListeAuftraggeber',

  AG_AVALLINIEN_DETAIL = 'avallinienDetailsAuftraggeber',

  AG_AVALLINIE_HINZUFUEGEN = 'auftraggeber_avallinie_hinzufuegen_base',
  AG_AVALLINIE_HINZUFUEGEN_KAUTIONSVERTRAG = 'auftraggeber_avallinie_hinzufuegen_kautionsvertrag_auswaehlen',
  AG_AVALLINIE_HINZUFUEGEN_RAHMEN = 'auftraggeber_avallinie_hinzufuegen_unternehmen_rahmen_eingeben',
  AG_AVALLINIE_HINZUFUEGEN_AVALZINS = 'auftraggeber_avallinie_hinzufuegen_avalzins_eingeben',
  AG_AVALLINIE_HINZUFUEGEN_STICHTAG = 'auftraggeber_avallinie_hinzufuegen_auslastung_stichtag_eingeben',

  AG_AVALLINIE_BEARBEITEN = 'auftraggeber_avallinie_bearbeiten_base',
  AG_AVALLINIE_BEARBEITEN_KAUTIONSVERTRAG = 'auftraggeber_avallinie_bearbeiten_kautionsvertrag_auswaehlen',
  AG_AVALLINIE_BEARBEITEN_RAHMEN = 'auftraggeber_avallinie_bearbeiten_unternehmen_rahmen_eingeben',
  AG_AVALLINIE_BEARBEITEN_AVALZINS = 'auftraggeber_avallinie_bearbeiten_avalzins_eingeben',
  AG_AVALLINIE_BEARBEITEN_STICHTAG = 'auftraggeber_avallinie_bearbeiten_auslastung_stichtag_eingeben',
}
